import { Field, Image, ImageField, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

import classNames from 'classnames/bind';
import styles from './CustomIconBulletedList.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';

type CustomIconBulletedListItemFields = {
  icon: ImageField;
  message: Field<string>;
};

export type CustomIconBulletedListItemProps = ComponentProps & {
  fields: CustomIconBulletedListItemFields;
  id: string;
};

const cx = classNames.bind(styles);

const CustomIconBulletedListItem = (props: CustomIconBulletedListItemProps): React.JSX.Element | null => {
  const { fields, id } = props;
  const { sitecoreContext } = useSitecoreContext();
  const noImageForListItem = fields?.icon?.value?.src === undefined;

  if (!sitecoreContext.pageEditing && noImageForListItem && !fields?.message?.value.length) {
    return null;
  }

  const classes: string = cx(
    {
      noImage: noImageForListItem,
    },
    'iconBulletedList__list-item'
  );
  return (
    <li id={`iconBulletedList__list-item-${id}`} className={classes}>
      <Image className={cx('iconBulletedList__list-icon')} field={fields.icon} />
      <RichTextWrapper className={cx('iconBulletedList__list-message')} field={fields?.message} tag="div" />
    </li>
  );
};

export default CustomIconBulletedListItem;
